import React, {Component} from "react";

import "./DocumentUploadingTab.css";
import {Button, message, Typography, Form, Row, Col, Divider, Switch} from "antd";
import UploadWrapper from "./UploadWrapper";
import {displayError, displayGenericError, displaySuccessMessage} from "../common/notifications";
import {
    deleteFile,
    findSchedule,

    upload
} from "../api/api";
import Radio from "antd/es/radio";

import "./DocumentIndividualUploadingTab.scss"
import 'react-day-picker/lib/style.css';

import ScheduleCorporateInfo from "./ScheduleCorporateInfo";
import "./DocumentUploadingTab.css";
const {Title, Text, Paragraph} = Typography;


class DocumentCorporateUploadingTab extends Component {
    state = {
        documents: this.props.customerAccount.corporateAccountDetails.documents || {},
        documentType: 'attachedDocument',
        isSubmitted: false,
    }
    handleUpload = ({file, type, index}) => {
        if (!(typeof index === "number")) {
            return upload({id: this.props.customerAccount.id, file, type})
                .then(res => {
                    this.setState({
                        documents: {
                            ...this.state.documents,
                            [type]: {
                                name: file.name,
                                size: file.size / 1024,
                                id: res.id
                            }
                        }
                    });
                })
                .catch(displayGenericError);
        }
    };
    handleRemoveFile = ({id, type, index}) => {
        deleteFile(id)
            .then(() => {
                if (!(typeof index === "number")) {
                    const {documents} = this.state;
                    delete documents[type];
                    this.setState({documents});
                }
            })
            .catch(displayGenericError);
    };
    onDocumentTypeChange = (event) =>{
        this.setState({
            documentType: event.target.value
        })
    }
    handleCorporateSubmit = (onboardingType, dateSelect, timeSelect) => {
        this.props.updateOnboardingForm({
            dateSelect: dateSelect,
            timeSelect: timeSelect,
            onboardingType: onboardingType,

        })
    }
    isSubmitButtonDisabled = () => {
        let response = false;
        if(this.state.documentType === 'attachedDocument'){
            if(!this.state.documents['CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION'] ||
                !this.state.documents['MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION'] ||
                !this.state.documents['COMPANY_SEARCH_REPORT'] ||
                !this.state.documents['BOARD_RESOLUTION_FOR_ACCOUNT_OPENING'] ){
                return true;
            }
        }else{

        }
        return response;
    }
    handleSubmit = () => {
        this.props.updateOnboardingForm({
            dateSelect:this.state.dateSelect,
            timeSelect: this.state.selectTime,
            onboardingType:this.state.documentType,
            documents:this.state.documents

        })
      //  this.props.handleSubmit(false);
    }
    render() {
        const {isSubmitted} = this.state;
        return (
            <div className="general-info-tab">
                <div className="left-pane">

                    <Row gutter={24}>
                        <Col md={24}>
                            <Title level={4}>Corporate Document</Title>
                            <div>
                                <Form.Item
                                    label="Document Type">
                                    <Radio.Group name="documentType" value={this.state.documentType}
                                                 onChange={this.onDocumentTypeChange}>
                                        <Radio.Button value="attachedDocument">Upload corporate documents</Radio.Button>
                                        <Radio.Button value="timeSchedule"> Sent to Operation’s email address</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </div>

                            {this.state.documentType === 'attachedDocument' && (
                                <div>
                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"
                                                ]
                                        }
                                        title="Certificate of Incorporation / Business Registration"
                                        type="CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}

                                    />

                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"
                                                ]
                                        }
                                        title="Memorandum and Articles of Association"
                                        type="MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}

                                    />

                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "COMPANY_SEARCH_REPORT"
                                                ]
                                        }
                                        title="Company Search Report / Certificate of Incumbency"
                                        type="COMPANY_SEARCH_REPORT"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}

                                    />



                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"
                                                ]
                                        }
                                        title="Board Resolution for Account Opening"
                                        type="BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}

                                    />
                                </div>
                            )}

                        </Col>

                    </Row>


                    {this.state.documentType === 'timeSchedule' && (
                        <ScheduleCorporateInfo prevTab={this.props.prevTab} handleCorporateSubmit={this.handleCorporateSubmit}/>)}
                    {this.state.documentType === 'attachedDocument' && (
                    <Row gutter={24}>
                        <Col md={24}>
                            <div className="button-wrapper">
                                <Button className="bt-skip" onClick={this.props.prevTab}>
                                    Back
                                </Button>
                                <Button
                                    className="bt-next"
                                    type="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.isSubmitButtonDisabled()}>
                                    Submit
                                </Button>
                                {this.isSubmitButtonDisabled() && (
                                    <>
                                        <br/><i>*Please upload your Corporate Document</i>
                                    </>
                                )}

                            </div>
                        </Col>
                    </Row>)}

                </div>



            </div>
        )
    }

}


export default DocumentCorporateUploadingTab;
